import React from "react";

function Colors_NBS() {
  return (
    <div>
      <h1>Colors_NBS Component</h1>
      <p>This is the Colors NBS tutorial page content.</p>
    </div>
  );
}

export default Colors_NBS;
